const initState = {
    // property for lowercase. 
    assetParts: "project segments",
    assetPart: "project segment",
    aloneAssetParts: "segments",
    aloneAssetPart: "segment",
    projects: "projects",
    project: "project",
    tagCategories: "categories",
    tagCategory: "category",
    drawings: "digital plans",
    drawing: "digital plan",
    defectMarkers: "tags",
    defectMarker: "tag",
    ownedBy: "axibuild",
    elevationCategoryKey: "elevation",
    unlimited: "unlimited",
    internalMembers: "internal members",
    externalMembers: "external members",
    companyMemberUsage: "company member usage",
    tagUsage: "total tag usage",
    tagLimit: "total tag limit",
    projectTagUsage: "project tag usage",
    projectTagLimit: "project tag limit",
    internalMemberUsage: "internal member usage",
    externalMemberUsage: "external member usage",

    // property for uppercase. 
    uassetParts: "Project segments",
    uassetPart: "Project segment",
    ualoneAssetParts: "Segments",
    ualoneAssetPart: "Segment",
    uprojects: "Projects",
    uproject: "Project",
    utagCategories: "Categories",
    utagCategory: "Category",
    udrawings: "Digital plans",
    udrawing: "Digital plan",
    udefectMarkers: "Tags",
    udefectMarker: "Tag",
    uOwnedBy: "AxiBuild",
    uelevationCategoryKey: "Elevation",
    uunlimited: "Unlimited",
    uinternalMembers: "Internal members",
    uexternalMembers: "External members",
    ucompanyMemberUsage: "Company member usage",
    utagUsage: "Total tag usage",
    utagLimit: "Total tag limit",
    uprojectTagUsage: "Project tag usage",
    uprojectTagLimit: "Project tag limit",
    uinternalMemberUsage: "Internal member usage",
    uexternalMemberUsage: "External member usage",

    // property for all uppercase. 
    auOwnedBy: "AXIBUILD",
    auunlimited: "UNLIMITED",

    deletedTagCategoryKey: "[DELETED]",
    defaultCategory: "Unclassified",

    // prices
    priceIn: '£',
}

const commonsReducer = (state = initState, action) => {
    return state
}

export default commonsReducer